module.exports = __webpack_public_path__ + "img/2.381a61d3.png";